module.exports = __webpack_public_path__ + "img/previewLogo.80fd4a15.png";